module.exports = __webpack_public_path__ + "static/media/91.0ba76219.webp";